import SuperRepository from '../superRepository'

export default new (class RetargetingAttributionRepository extends SuperRepository {
  baseUri() {
    return 'retargeting_attribution'
  }
  report = ({ signal, ...data }) => this.httpClient().post(`${this.baseUri()}/report`, data, { signal })
  segments = params => this.httpClient().get(`${this.baseUri()}/segments`, params)
})()
